<template>
<div>
<tabs nav-style="tabs" v-model="activeTabIndex">
    <tab header="Isolated Resource Form">
        <projectHeader v-show="project" :project="project"></projectHeader>
        <investigationHeader v-show="investigation" v-bind:investigation="investigation"></investigationHeader>
        <isolateHeader :isolate="isolateDto"></isolateHeader>
        <fieldset :disabled="formDisabled">
            <form @submit.prevent class="form form-horizontal" data-vv-scope="isolateDto">
                <!-- <div class="row">
                    <div class="form-group">
                        <label class="col-md-2 control-label">County</label>
                        <div class="col-md-4">
                            <div class="control-label" style="text-align: left;">
                                {{isolateDto.countyCodeList}}
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="row">
                    <div class="form-group">
                        <div v-bind:class="{ 'has-error': errors.has('isolateDto.resourceType') }">
                            <label class="col-md-2 control-label">Resource Type</label>
                            <div class="col-md-4">
                                <input name="resourceType" class="form-control" v-model="isolateDto.resourceType" v-validate="'required'" aria-required="true"/>
                                <span v-show="errors.has('isolateDto.resourceType')" class="has-error">Resource Type is required</span>
                            </div>
                        </div>
                        <div v-bind:class="{ 'has-error': errors.has('isolateDto.fieldNumber') }">
                            <label class="col-md-2 control-label">Field Number</label>
                            <div class="col-md-4">
                                <input name="fieldNumber" class="form-control" v-model="isolateDto.fieldNumber" v-validate="'required'" aria-required="true"/>
                                <span v-show="errors.has('isolateDto.fieldNumber')" class="has-error">Field Number is required</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group">
                        <div v-bind:class="{ 'has-error': errors.has('isolateDto.recorderName') }">
                            <label class="col-md-2 control-label">Name of Recorder</label>
                            <div class="col-md-4">
                                <input name="recorderName" class="form-control" v-model="isolateDto.recorderName" v-validate="'required'" aria-required="true"/>
                                <span v-show="errors.has('isolateDto.recorderName')" class="has-error">Recorder Name is required</span>
                            </div>
                        </div>
                        <div v-bind:class="{ 'has-error': errors.has('isolateDto.recordingDate') }">
                            <label class="col-md-2 control-label">Date</label>
                            <div class="col-md-4">
                                <el-date-picker v-model="isolateDto.recordingDate" type="date" format="MM/dd/yyyy" placeholder="Select recording Date"></el-date-picker>
                                <input name="recordingDate" type="hidden" v-model="isolateDto.recordingDate" v-validate="'required'"/>
                                <div><span v-show="errors.has('isolateDto.recordingDate')" class="has-error">Recording Date is required</span></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group" v-bind:class="{ 'has-error': errors.has('isolateDto.landownerTypeId') }">
                        <label class="col-md-2 control-label">Landowner</label>
                        <div class="col-md-4">
                            <select name="landownerTypeId" class="form-control" v-model="isolateDto.landownerTypeId" v-validate="'required'" aria-required="true">
                                <option disabled value="">Select a value</option>
                                <option v-for="landownerType in landownerList" v-bind:value="landownerType.id">
                                    {{landownerType.description}}
                                </option>
                            </select>
                            <span v-show="errors.has('isolateDto.landownerTypeId')" class="has-error">Landowner is required</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group" v-bind:class="{ 'has-error': errors.has('isolateDto.materialsCollectedId') }">
                        <label class="col-md-2 control-label">Collections</label>
                        <div class="col-md-3" style="padding-left:20px">
                            <label><span>Were materials collected as part of this recording</span></label>
                            <select name="materialsCollectedId" class="form-control" v-model="isolateDto.materialsCollectedId" v-validate="'required'" aria-required="true">
                                <option  disabled value="">Select a value</option>
                                <option :value="1">Yes</option>
                                <option :value="2">No</option>
                                <option :value="3">Unknown</option>
                            </select>
                            <span v-show="errors.has('isolateDto.materialsCollectedId')" class="has-error">Collections is required</span>
                        </div>
                        <div class="col-md-3" v-if="isolateDto.materialsCollectedId == 1" v-bind:class="{ 'has-error': errors.has('isolateDto.repositoryId') }">
                            <label>&nbsp;</label>
                            <select name="repositoryId" class="form-control" v-model="isolateDto.repositoryId" v-validate="isolateDto.materialsCollectedId == 1 ? 'required' : ''">
                                <option  disabled value="">Select a Repository</option>
                                <option value=1>U.W. Archaeological Repository</option>
                                <option value=2>Western Wyoming College</option>
                                <option value=3>Other</option>
                            </select>
                            <span v-show="errors.has('isolateDto.repositoryId')" class="has-error">Repository is required</span>
                        </div>
                        <div class="col-md-3" v-if="isolateDto.materialsCollectedId == 1 && isolateDto.repositoryId == 3" v-bind:class="{ 'has-error': errors.has('isolateDto.otherRepository') }">
                            <label>&nbsp;</label>
                            <input name="otherRepository" type="text" class="form-control" placeholder="Other Repository" v-model="isolateDto.otherRepository" v-validate="isolateDto.repositoryId == 3 ? 'required' : ''"/>
                            <span v-show="errors.has('isolateDto.otherRepository')" class="has-error">Repository is required</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group"  v-bind:class="{ 'has-error': errors.has('isolateDto.environmentalDescription') }">
                        <label class="col-md-2 control-label">Environmental Description</label>
                        <div class="col-md-10">
                            <label><span>Discuss topography, vegetation, soils, slope, hydrology, on-site depositional environment</span></label>
                            <textarea name="environmentalDescription" class="form-control" rows="4" v-model="isolateDto.environmentalDescription" v-validate="'required'" aria-required="true"/>
                            <span v-show="errors.has('isolateDto.environmentalDescription')" class="has-error">Environmental Description is required</span>
                        </div>
                    </div>
                </div>
                <div class ="row">
                    <div class="form-group" v-bind:class="{ 'has-error': errors.has('isolateDto.resourceDescription') }">
                        <label class="col-md-2 control-label">Resource Description</label>
                        <div class="col-md-10">
                            <label><span>Describe and discuss artifact type(s), observed raw material(s), dimensions, function, time period</span></label>
                            <textarea name="resourceDescription" class="form-control" rows="4" v-model="isolateDto.resourceDescription" v-validate="'required'" aria-required="true"/>
                            <span v-show="errors.has('isolateDto.resourceDescription')" class="has-error">Resource Description is required</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-10" v-if="!formDisabled"><button class="btn btn-primary" v-on:click="saveIsolate">Save</button></div>
                </div>
            </form>
        </fieldset>
    </tab>
    <tab header="Documents" :disabled="!isolateDto.isolateId">
        <projectHeader v-show="project" :project="project"></projectHeader>
        <investigationHeader v-show="investigation" v-bind:investigation="investigation"></investigationHeader>
        <isolateHeader :isolate="isolateDto"></isolateHeader>
        <h3>Shape File</h3>
        <media :mediaTypeId="mediaTypeIdIsolate" :parentId="isolateDto.isolateId" :formDisabled="formDisabled" type="isolateShapeFile" ref="shapeFileMedia"></media>
        <h3>Other</h3>
        <media :mediaTypeId="mediaTypeIdIsolate" :parentId="isolateDto.isolateId" :formDisabled="formDisabled" type="isolateOtherFile" ref="otherMedia"></media>
        <div style="margin-top: 20px;">
            <mediaLetter :mediaTypeId="mediaTypeIdIsoLetter" :parentId="isolateDto.isolateId"></mediaLetter>
        </div>
    </tab>
    <tab header="Complete Form" :disabled="!isolateDto.isolateId">
        <projectHeader v-show="project" :project="project"></projectHeader>
        <investigationHeader v-show="investigation" v-bind:investigation="investigation"></investigationHeader>
        <isolateHeader :isolate="isolateDto"></isolateHeader>
        <h3>Complete</h3>
        <workflow :workflowId="6000" :parentId="isolateDto.isolateId" ref="workflow" v-on:workflowOnSubmitSuccess="workflowOnSubmitSuccess"></workflow>
        <div v-if="isShpo" style="margin-top: 20px;">
            <quickLetter :projectId="investigation.projectId" :investigationId="investigation.investigationId" :isolateId="isolateDto.isolateId"
            :mediaTypeId="mediaTypeIdIsoLetter" :parentId="isolateDto.isolateId"></quickLetter>
        </div>
        <div v-if="isolateDto.isolateId">
            <button :disabled="reportLoading" name="isolateReport" class="btn btn-primary" v-on:click="genIsolateReport">Generate Isolate Report</button>
        </div>
    </tab>
    <tab v-if="showAssociatedIsolatesTab" header="Associated Isolates">
        <projectHeader v-show="project" :project="project"></projectHeader>
        <investigationHeader v-show="investigation" v-bind:investigation="investigation"></investigationHeader>
        <isolateHeader :isolate="isolateDto"></isolateHeader>
        <h3>Search and Add Associated Isolates</h3>

        <div class="row">
            <form @submit.prevent class="form-horizontal">
                <div class="form-group">
                    <div class="col-sm-2">
                        <label for="searchIsolateNumber">File Number</label>
                    </div>
                    <div class="col-sm-3">
                        <input class="form-control" type="text" name="searchIsolateNumber" v-model="isolateSearchDto.isolateNumber">
                    </div>
                    <div class="col-sm-2 col-sm-offset-1">
                        <label for="searchFieldNumber">Field Number</label>
                    </div>
                    <div class="col-sm-4">
                        <input class="form-control" type="text" name="searchFieldNumber" v-model="isolateSearchDto.fieldNumber">
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-sm-2">
                        <label for="searchNIRecId">Isolate NIRecId</label>
                    </div>
                    <div class="col-sm-3">
                        <input class="form-control" type="text" name="searchNIRecId" v-model="isolateSearchDto.NIRecId">
                    </div>
                    <div class="col-sm-2 col-sm-offset-1">
                        <label for="searchResourceType">Resource Type</label>
                    </div>
                    <div class="col-sm-4">
                        <input class="form-control" type="text" name="searchResourceType" v-model="isolateSearchDto.resourceType">
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-sm-2">
                        <label for="searchIsoLandowner">Landowner</label>
                    </div>
                    <div class="col-sm-3">
                        <select class="form-control" name="searchIsoLandowner" v-model="isolateSearchDto.landownerTypeId">
                            <option :value="null">Select</option>
                            <option v-for="lo in isoLandownerList" :value="lo.id" :key="lo.id">{{lo.description}}</option>
                        </select>
                    </div>
                    <div class="col-sm-2 col-sm-offset-1">
                        <label for="searchMaterialsCollected">Materials Collected</label>
                    </div>
                    <div class="col-sm-4">
                        <select name="searchMaterialsCollected" class="form-control" v-model="isolateSearchDto.materialsCollectedId" v-validate="'required'" aria-required="true">
                            <option :value="null">Select a value</option>
                            <option :value="1">Yes</option>
                            <option :value="2">No</option>
                            <option :value="3">Unknown</option>
                        </select>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-sm-2">
                        <label for="searchProjName">Project Name</label>
                    </div>
                    <div class="col-sm-3">
                        <input class="form-control" type="text" name="searchProjName" v-model="isolateSearchDto.projectName">
                    </div>
                    <div class="col-sm-2 col-sm-offset-1">
                        <label for="searchReportTitle">Report Title</label>
                    </div>
                    <div class="col-sm-4">
                        <input class="form-control" type="text" name="searchReportTitle" v-model="isolateSearchDto.reportTitle">
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-sm-2">
                        <label for="searchInvDbNumber">DBI Number</label>
                    </div>
                    <div class="col-sm-3">
                        <input class="form-control" type="text" name="searchInvDbNumber" v-model="isolateSearchDto.invDbNumber">
                    </div>
                    <div class="col-sm-2 col-sm-offset-1">
                        <label for="searchFieldOrg">Field Org</label>
                    </div>
                    <div class="col-sm-4">
                        <input class="form-control" type="text" name="searchFieldOrg" v-model="isolateSearchDto.fieldOrg">
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-sm-2">
                        <label for="searchReportYear">Report Year</label>
                    </div>
                    <div class="col-sm-3">
                        <input class="form-control" type="number" min="0" step="1" name="searchReportYear" v-model="isolateSearchDto.reportYear">
                    </div>
                    <div class="col-sm-2 col-sm-offset-1">
                        <label for="searchRevNo">Rev No (Legacy)</label>
                    </div>
                    <div class="col-sm-3">
                        <input class="form-control" type="text" name="searchRevNo" v-model="isolateSearchDto.revNo">
                    </div>

                </div>
                <div class="form-group">
                    <div class="col-sm-2">
                        <label for="searchN9RecId">N9RecId (Legacy)</label>
                    </div>
                    <div class="col-sm-3">
                        <input class="form-control" type="text" name="searchN9RecId" v-model="isolateSearchDto.n9RecId">
                    </div>
                    <div class="col-sm-2 col-sm-offset-1">
                        <label for="searchAcno">ACNO (Legacy)</label>
                    </div>
                    <div class="col-sm-3">
                        <input class="form-control" type="text" name="searchAcno" v-model="isolateSearchDto.acno">
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-sm-2">
                        <label for="searchArtifacts" class="control-label">
                            Counties
                        </label>
                    </div>
                    <div class="col-sm-10">
                        <span>{{selectedIsoCountyDesc}}</span>
                        <button class="btn btn-secondary" type="button" name="button" v-on:click="$refs['isoCountyModal'].open()">Select</button>
                    </div>
                    <modal ref="isoCountyModal">
                        <div slot="header" class="">
                            <h3 class="pull-left">Select Counties</h3>
                            <button class="btn pull-right" v-on:click="$refs['isoCountyModal'].close()">X</button>
                        </div>
                        <div slot="body">
                            <form @submit.prevent class="form-horizontal">
                                <div class="form-group">
                                    <div class="checkbox checkbox-inline" v-for="county in countyList" :key="'iso_co_' + county.countyId">
                                        <input class="form-check-input" type="checkbox" v-model="isolateSearchDto.countyList" :id="'iso_' + county.countyId + county.description" :value="county.countyId" />
                                        <label class="form-check-label" :for="'iso_' + county.countyId + county.description">{{county.description}}</label>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div slot="footer">
                            <div class="">
                                <button class="btn btn-primary col-md-3" type="button" name="clear" v-on:click="clearIsoSelectedCountyList()">Clear</button>
                                <button class="btn btn-primary col-md-3" type="button" name="cancel" v-on:click="$refs['isoCountyModal'].close()">Close</button>
                            </div>
                        </div>
                    </modal>
                </div>
                <div class="form-group" style="margin-top:10px;">
                    <div class="col-md-12">
                        <button class="btn btn-primary" type="button" name="button" v-on:click="searchIsolateData()">Search</button>
                        <button class="btn" type="button" name="button" v-on:click="clearIsoSearch()">Clear All</button>
                    </div>
                </div>
            </form>

            <div>
                <h3>Search Results</h3>
                <v-client-table
                    :data="searchResults"
                    :columns="resultsColumns"
                    :options="resultsOptions"
                >
                    <template slot="actionAdd" slot-scope="props">
                        <button
                            v-on:click="addAssociatedIsolate(props.row.isolateId)"
                            class="btn"
                            type="button"
                            name="button"
                        >Add Association</button>
                    </template>
                </v-client-table>
            </div>
        </div>

        <div>
            <h3>Associated Isolates</h3>
            <v-client-table
                :data="associatedIsolateDtos"
                :columns="assocColumns"
                :options="assocOptions"
            >
                <template slot="actionDelete" slot-scope="props">
                    <button
                        v-on:click="removeAssociatedIsolate(props.row.isolateId)"
                        class="btn"
                        type="button"
                        name="button"
                    >Remove Association</button>
                </template>
            </v-client-table>
        </div>
    </tab>
</tabs>
</div>
</template>

<script>
import isolateService from '@/services/isolateService'
import dateService from '@/services/util/dateService'
import loggingService from '@/services/util/loggingService'
import workflowService from '@/services/workflowService'
import investigationService from '@/services/investigationService'
import projectService from '@/services/projectService'
import { tab, tabs } from 'vue-strap'
import media from '@/components/Media.vue'
import mediaLetter from '@/components/MediaLetter.vue'
import quickLetter from '../components/QuickLetter.vue'
import workflow from '@/components/Workflow.vue'
import investigationHeader from '@/components/InvestigationHeader.vue'
import projectHeader from '../components/ProjectHeader.vue'
import isolateHeader from '../components/IsolateHeader.vue'
import countyService from '@/services/lookup/countyService'
import landOwnershipService from '@/services/landOwnershipService'
import modal from '@/components/Modal.vue'

import roleService from '@/services/roleService.js'
import userService from '@/services/userService.js'
import mediaService from '@/services/mediaService.js'
import { mapState } from 'vuex'

export default {
    name: 'isolate',
    components: {
        tab,
        tabs,
        media,
        workflow,
        investigationHeader,
        projectHeader,
        isolateHeader,
        mediaLetter,
        quickLetter,
        modal
    },
    data: function () {
        return {
            isDebug: false,
            landownerList: isolateService.getLandownerList(),
            isolateDto: {},
            isolateSearchDto: {
                countyList: []
            }, // as IsolateSearchDto
            searchResults: [], // as Isolate[]
            investigation: {},

            associatedIsolateDtos: [], // as Isolate[]
            // grid specs are shared between both tables. see calculated props resultColumns and assocColumns
            // for an example of what this looks like
            assocGridSpec: {
                columns: ['isolateNumber', 'fieldNumber', 'dbiNumber', 'resourceType', 'recordingDate', 'groupSize', 'actionAdd', 'actionDelete'],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['recordingDate'],
                    headings: {
                        isolateNumber: 'Isolate Number',
                        dbiNumber: 'DBI Number',
                        fieldNumber: 'Field Number',
                        groupSize: 'Group Size',
                        resourceType: 'Resource Type',
                        recordingDate: 'Recording Date',
                        actionAdd: 'Add Association',
                        actionDelete: 'Remove Association'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'recordingDate'
                    }
                }
            },

            isolateWorkflowId: workflowService.WorkflowEnum.Isolate,
            isoLandownerList: isolateService.getLandownerList(),
            countyList: [],
            activeTabIndex: -1,
            reportLoading: false,
            project: {}
        }
    },
    mounted () {
        this.isLoading = true
        this.loadData().then(result => {
            this.isLoading = false
            this.log('Done loading data')
        })
    },
    computed: {
        // compute current user info
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        // disable forms if user is not consultant or admin, and investigation was not created by agency or SHPO
        formDisabled: function () {
            return (!this.isAdmin && !this.hasConsultantAccess && !this.hasAgencyAccess && !this.hasShpoAccess)
        },
        isAdmin: function () {
            var roleList = [roleService.RoleEnum.Administrator, roleService.RoleEnum.ShpoAdministrator]
            return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, roleList))
        },
        isShpoReadOnly: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoReadOnlyRoleList)
        },
        hasConsultantAccess: function () {
            return !this.isSubmitted && userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.ConsultantUser])
        },
        hasAgencyAccess: function () {
            return (this.investigation.recordCreatedBy === 'Agency' || !this.isSubmitted) &&
                (userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.BlmUser]))
        },
        hasShpoAccess: function () {
            if (this.isShpo) {
                if (this.isShpoReadOnly) {
                    return this.shpoCrBacklog
                } else {
                    return (this.investigation.recordCreatedBy === 'SHPO' || this.investigation.isE106Investigation)
                }
            } else {
                return false
            }
        },
        isShpo: function () {
            return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoRoleList))
        },
        mediaTypeIdIsolate: function () {
            return mediaService.mediaType.Isolate
        },
        mediaTypeIdIsoLetter: function () {
            return mediaService.mediaType.IsolateLetter
        },
        shpoCrBacklog: function () {
            return this.isShpoReadOnly && this.investigation.isQaqcBacklog
        },
        isSubmitted: function () {
            return this.isolateDto.isolateId && this.isolateDto.workflowStatusId > 6000
        },
        selectedIsoCountyDesc: function () {
            var selectedCountyDescList = this.isolateSearchDto.countyList.map(x => {
                return (this.countyList.find(y => y.countyId === x) || {description: ''}).description
            })
            return selectedCountyDescList.join(', ')
        },
        showAssociatedIsolatesTab () {
            return userService.hasRoleCheck(
                this.shpoUserDto.roleList, [
                    roleService.RoleEnum.Administrator,
                    roleService.RoleEnum.ShpoAdministrator,
                    roleService.RoleEnum.ShpoCrApprovingUser,
                    roleService.RoleEnum.ShpoCrDataEntryUser
                ]
            )
        },
        resultsColumns () {
            return this.assocGridSpec.columns.filter(c => c !== 'actionDelete')
        },
        resultsOptions () {
            return this.assocGridSpec.options
        },
        assocColumns () {
            return this.assocGridSpec.columns.filter(c => c !== 'actionAdd' && c !== 'groupSize')
        },
        assocOptions () {
            return this.assocGridSpec.options
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Isolate form', message)
        },
        clearIsoSearch () {
            this.isolateSearchDto = {
                countyList: []
            }
        },
        clearIsoSelectedCountyList () {
            this.isolateSearchDto.countyList = []
        },
        createIsolate () {
            this.log('Creating Isolate, investigationId: ' + this.$route.query.investigationId)
            this.isolateDto = {
                investigationId: this.$route.query.investigationId,
                landownerTypeId: '',
                materialsCollectedId: '',
                repositoryId: ''
            }
        },
        loadAssociatedIsolates () {
            this.log('Loading Associated Isolates')
            isolateService.getAssociatedIsolates(this.$http, this.isolateDto.isolateId)
                .then(res => {
                    this.associatedIsolateDtos = res.data.map(i => ({
                        ...i,
                        recordingDate: i.recordingDate.split('T')[0]
                    }))
                })
        },
        loadIsolate () {
            this.log('Loading Isolate')
            if (this.$route.params.isolateId) {
                return isolateService.get(this.$http, this.$route.params.isolateId).then(response => {
                    this.isolateDto = response.data
                    return response
                })
            } else {
                return Promise.resolve(this.createIsolate())
            }
        },
        loadInvestigation () {
            return investigationService.get(this.$http, this.isolateDto.investigationId).then(response => {
                this.investigation = response.data
                projectService.get(this.$http, this.investigation.projectId).then(response2 => {
                    loggingService.log(this.isDebug, 'Cultural Resource Recording', 'loading project:' + this.investigation.projectId)
                    this.project = response2.data
                    return response
                })
            })
        },
        loadData () {
            return this.loadIsolate().then(result => {
                this.loadInvestigation()
                // these values are only used if we can view the associated isolates tab, so to prevent
                // slower loading times for other users, we only conditionally load that data
                if (this.showAssociatedIsolatesTab) {
                    this.loadLookups()
                    this.loadAssociatedIsolates()
                }
                return result
            })
        },
        loadLookups () {
            var promises = [
                landOwnershipService.listLandownerTypes(this.$http),
                countyService.listLookup(this.$http)
            ]

            return Promise.all(promises).then(responses => {
                this.landOwnerTypeList = responses[0].data
                this.countyList = responses[1].data
                return responses
            })
        },
        saveIsolate () {
            this.$validator.validateAll('isolateDto').then(result => {
                if (result) {
                    this.log('Saving Isolate')
                    var handle = this
                    isolateService.put(this.$http, this.isolateDto).then(response => {
                        var url = '/Isolate/' + response.data.objectList[0].isolateId
                        handle.$router.push(url)
                        handle.loadData()
                    })
                } else {
                    this.log(this.isDebug, 'Isolate', 'submit - invalid form')
                }
            })
        },
        searchIsolateData () {
            this.isLoading = true
            isolateService.searchExtendedAssociations(this.$http, this.isolateSearchDto).then(result => {
                this.searchResults = result.data
                this.isLoading = false
            })
        },
        workflowOnSubmitSuccess (submitValidationResult) {
            //trigger media letter refresh if letter gen is triggered
            if (submitValidationResult.letterGenTriggered && this.$refs.mediaLetter) {
                this.$refs.mediaLetter.autoRefreshMedia()
            }
            //go back to investigation
            this.$router.push('/Investigation/' + this.investigation.investigationId + '#siteSummary')
        },
        genIsolateReport () {
            this.reportLoading = true
            if (this.isolateDto.isolateId) {
                isolateService.isolateReportGen(this.$http, this.isolateDto.isolateId).then(response => {
                    mediaService.saveFileToDownload(response, this.isolateDto.isolateNumber + '_' + 'WYIRF.pdf')
                    this.reportLoading = false
                })
            } else {
                this.reportLoading = false
            }
        },
        addAssociatedIsolate (associatedIsolateId) {
            isolateService.addAssociatedIsolate(this.$http, this.isolateDto.isolateId, associatedIsolateId)
                .then((res) => {
                    if (!res.data.isValid) {
                        res.data.messages.forEach(m => {
                            this.$store.commit('addError', {
                                time: dateService.toStringNow(),
                                message: m
                            })
                        })
                    }

                    this.loadAssociatedIsolates()
                })
        },
        removeAssociatedIsolate (associatedIsolateId) {
            isolateService.deleteAssociatedIsolate(this.$http, associatedIsolateId)
                .then((res) => {
                    if (!res.data.isValid) {
                        res.data.messages.forEach(m => {
                            this.$store.commit('addError', {
                                time: dateService.toStringNow(),
                                message: m
                            })
                        })
                    }

                    this.loadAssociatedIsolates()
                })
        }
    }
}
</script>



// WEBPACK FOOTER //
// Isolate.vue?4b3ac70e